<template>
    <v-row justify="center">
        <v-dialog v-model="formDialog" persistent scrollable max-width="500">
            <ValidationObserver ref="obs" v-slot="{handleSubmit}">
                <v-card>
                    <v-progress-linear
                        v-if="loading"
                        indeterminate
                        color="primary"
                        rounded
                        height="6"
                    ></v-progress-linear>

                    <v-card-title class="pa-0 shadow-1">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_modal_card.svg')
                            "
                            cover
                            position="left bottom"
                            class="align-center"
                            height="65px"
                        >
                            <v-card-title
                                class="font-weight-medium primary--text"
                            >
                                {{ titleMode }} Proceso
                            </v-card-title>
                        </v-img>
                    </v-card-title>

                    <vuescroll
                        :ops="{
                            bar: { background: '#bacfcec0', keepShow: true }
                        }"
                    >
                        <v-card-text style="max-height: 350px">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Categoria"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-select
                                                :items="CategoriesList"
                                                v-model="categorySelected"
                                                :error-messages="errors"
                                                item-value="id"
                                                item-text="title"
                                                prepend-inner-icon="mdi-label-variant"
                                                class="rounded-small"
                                                label="Categoria"
                                                required
                                                filled
                                                rounded
                                                dense
                                            ></v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Pregunta"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-select
                                                :items="Questions"
                                                v-model="processData.question_id"
                                                :error-messages="errors"
                                                item-text="name"
                                                item-value="id"
                                                class="rounded-small"
                                                label="Pregunta"
                                                prepend-inner-icon="mdi-label-variant"
                                                required
                                                filled
                                                rounded
                                                dense
                                            ></v-select>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Critico"
                                            v-slot="{}"
                                        >
                                            <v-checkbox
                                                required
                                                filled
                                                rounded
                                                class="rounded-small pl-6"
                                                dense
                                                v-model="processData.critical"
                                                label="Crítico"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Valor"
                                            rules="required|numeric|min_value:1"
                                            v-slot="{ errors }"
                                        >
                                            <v-text-field
                                                required
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Valor"
                                                prepend-inner-icon="mdi-label-variant"
                                                type="text"
                                                color="blue-grey"
                                                v-model.number="processData.value"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </vuescroll>
                    <v-divider></v-divider>

                    <v-card-actions class="mx-2">
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                text
                                rounded
                                class="mr-1"
                                :color="hover ? 'error' : 'grey'"
                                @click="closeDialog"
                                >Cancelar</v-btn
                            >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                rounded
                                :loading="loading"
                                :disabled="loading"
                                color="success"
                                :class="hover ? 'shadow-2' : 'shadow-4'"
                                class="px-8"
                                @click.stop="handleSubmit(submitForm)"
                                >{{ submitButtonMode }}</v-btn
                            >
                        </v-hover>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
    </v-row>
</template>

<script>
import vuescroll from "vuescroll";

export default {
    props: {
        formDialog: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: "register"
        },
        dataToForm: {
            type: Object
        },
        idEvaluation: {
            type: Number
        }
    },
    components: { vuescroll },
    data() {
        return {
            loading: false,
            activeAlert: false,
            errorData: "",
            colorAlert: "",
            processData: { 
                evaluation_id: this.idEvaluation,
                critical: false,
                value: null,
                question_id: null 
            },
            CategoriesList: [],
            //Question Select
            categorySelected: null,
        };
    },
    //   beforeUpdate() {
    //     if (this.mode !== "register") this.processData = { ...this.dataToForm };
    //   },
    async created() {
        await this.getCategories();
        if (this.mode !== "register") {
            this.categorySelected =  this.dataToForm.question.category_id
            const { created_at,question, updated_at, ...data } = this.dataToForm
            this.processData = data;
        }
    },
    computed: {
        Questions() {
            return this.categorySelected
                ? this.CategoriesList.find(
                      c => c.id === this.categorySelected
                  ).questions
                : [];
        },
        titleMode() {
            return this.mode === "register" ? "Nuevo" : "Editar";
        },
        submitButtonMode() {
            return this.mode === "register" ? "añadir" : "actualizar";
        }
    },

    methods: {
        closeDialog() {
            this.$emit("processFormDialog:close");
        },
        async submitForm() {
            this.loading = true;
            if (this.mode === "register") {
                const response = await this.$store.dispatch(
                    "process/REGISTER_PROCESS",
                    this.processData
                );
                if (response === 422) {
                    this.$snotify.error(
                        "La suma de la respuesta es mayor a 100%",
                        "Error"
                    );
                    return;
                } else
                    this.$snotify.success(
                        "Respuesta creada con éxito.",
                        "¡Hecho!"
                    );
            } else {
                const response = await this.$store.dispatch(
                    "process/EDIT_PROCESS",
                    this.processData
                );
                if (response === 422 || this.processData.value > 100) {
                    this.$snotify.error(
                        "La suma de la respuesta es mayor a 100%",
                        "Error"
                    );
                    this.loading = false;
                    return;
                } else
                    this.$snotify.success(
                        "Respuesta actualizada con éxito.",
                        "¡Hecho!"
                    );
            }
            this.loading = false;
            this.closeDialog();
        },
        async getCategories() {
            try {
                const res = await this.$store.dispatch(
                    "categories/GET_ALL_CATEGORIES"
                );
                this.CategoriesList = res;
                // console.log("Categories List:", response.data);
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>
